import request from '@/utils/request'

export function getMyTeam(pageNum,userId) {
  return request({
    url: '/api/user/officialList',
    method: 'get',
    params: {
      userId,
      pageNum
    }
  })
}

export function resetWithdrawPassword(id) {
  return request({
    url: '/api/user/reset/'+id,
    method: 'post',
  })
}

export function activeUser(id) {
  return request({
    url: '/api/user/active/'+id,
    method: 'post',
  })
}

export function disableUser(id) {
  return request({
    url: '/api/user/disable/'+id,
    method: 'post',
  })
}

export function enableUser(id) {
  return request({
    url: '/api/user/enable/'+id,
    method: 'post',
  })
}